import { SurfaceDefectsPage } from "./SurfaceDefectsPage";

const SurfaceDefects = () => {
	return <SurfaceDefectsPage />;
};

export default SurfaceDefects;
